/**
 * يجلب الأوسمة المفعَّلة من Supabase RPC مرّة واحدة عند التحميل
 * ويستبدل القوائم الافتراضيّة في scentTaxonomy.ts عبر applyTaxonomyOverrides.
 * يُركَّب في __root مرّة واحدة، لا يُعرض شيئاً.
 */
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { applyTaxonomyOverrides, type ScentTagOverride } from "@/lib/scentTaxonomy";

let LOADED = false;

export function ScentTaxonomyLoader() {
  useEffect(() => {
    if (LOADED) return;
    LOADED = true;
    (async () => {
      try {
        const { data, error } = await supabase.rpc("list_active_scent_tags");
        if (error || !Array.isArray(data) || data.length === 0) return;
        applyTaxonomyOverrides(data as ScentTagOverride[]);
      } catch {
        /* swallow — seeds remain in effect */
      }
    })();
  }, []);
  return null;
}
